import { render, staticRenderFns } from "./KlfsFooter.vue?vue&type=template&id=9a283ef8&scoped=true"
import script from "./KlfsFooter.vue?vue&type=script&lang=js"
export * from "./KlfsFooter.vue?vue&type=script&lang=js"
import style0 from "./KlfsFooter.vue?vue&type=style&index=0&id=9a283ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a283ef8",
  null
  
)

export default component.exports